import { DateTime } from 'luxon'
import axios from 'axios'
import { API } from 'constants/apiEndPoints'
import { useCallback, useEffect, useState } from 'react'
import { ASSETS_TYPES } from 'constants/assets'

const parseData = (d) => ({
  date: DateTime.fromISO(d.t, { zone: 'utc' }).toJSDate(),
  open: +d.o,
  high: +d.h,
  low: +d.l,
  close: +d.c,
  volume: +d.v,
})

function getData(symbol, type, interval) {
  //ugly exceptions
  if (symbol === 'XBT/USD') symbol = 'BTC/USD'
  if (symbol === 'MONG/USD') type = 'memecoin_spot'
  if (symbol === '1000PEPE/USD') type = 'crypto'
  if (symbol === '1000FLOKI/USD') type = 'crypto'
  if (symbol === '10000LADYS/USD') type = 'crypto'
  //end of ugly exceptions
  const promiseCompare = axios
    .get(API.PRICE_DATA_OHLC, {
      params: {
        type,
        symbol,
        interval,
      },
    })
    .then((res) => {
      return res.data.body
    })
    .then((data) => {
      const processedData = data.map((item) => parseData(item))
      return processedData
    })
    .catch((err) => {
      return ['error']
    })
  return promiseCompare
}

export const useCandlesValues = (activeAsset) => {
  const { id: assetId, type } = activeAsset

  const [lastCandle, setLastCandle] = useState({})

  const getCandles = useCallback(async () => {
    //Fetching data from Backend
    const allCandles = await getData(assetId, type, '60')
    if (allCandles.includes('error')) {
      console.log('ACZ: error', { allCandles })
      return
    }
    const lastCandle = allCandles.at(-1)
    setLastCandle(lastCandle)
    console.log('ACZ:', { allCandles })
    console.log('ACZ:', { lastCandle })
  }, [assetId, type])

  useEffect(() => {
    getCandles()
  }, [getCandles])

  return { lastCandle }
}
